import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-20 md:py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Beautiful%20warm%20abstract%20background%20with%20soft%20golden%20and%20rose%20gradients%2C%20elegant%20flowing%20shapes%2C%20luxurious%20sophisticated%20atmosphere%2C%20modern%20minimalist%20design%20with%20subtle%20texture&width=1920&height=600&seq=cta-bg-01&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary-900/90 to-background-950/85"></div>
      </div>

      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-3xl md:text-4xl font-bold text-white mb-4">
          准备好探索精彩的直播世界了吗？
        </h2>
        <p className="text-white/75 text-base md:text-lg mb-8 max-w-xl mx-auto leading-relaxed">
          加入我们，与500+高颜值主播实时互动。才艺表演、游戏陪玩、生活分享，精彩内容24小时不间断。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/categories"
            className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-accent-500 text-background-950 font-semibold text-base hover:bg-accent-400 transition-all duration-300 whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
          >
            <i className="ri-live-line text-lg"></i>
            立即进入直播间
          </Link>
          <Link
            to="/about"
            className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-white/15 backdrop-blur-sm border border-white/25 text-white font-medium text-base hover:bg-white/25 transition-all duration-300 whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
          >
            <i className="ri-information-line"></i>
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}